

/*
    !! Source of truth for API endpoints !!

    add new endpoints in this object

    - top-level keys are router names
    - second-level keys are friendly names for an endpoint
    - values are the endpoints used in the request handler
        - endpoints can still be suffixed with '/:id' in the request handler

    FOR SUB-ROUTES such as '/content/:id/like' then specify that whole endpoint
    OR use '/content/:id/action' and apply query strings ('?action=like' ~~ const { action } = req.query) in the request handler if there will be multiple similar actions
*/
const endpoints = {
    app: {
        publicResource: '/public-resource',
        user: '/user',
        roadmap:'/roadmap',
        completion: '/completion',
        userChatHistory: '/user-chat-history',
        chat: '/chat',
        knowledge: '/knowledge',
        completeOnboarding:'/complete-onboarding',
        checkTask: '/check-task',
        dailyTips: '/daily-tips',
        biteSizeSteps: '/bite-size-steps',
        checkBiteSizeStep: '/check-bite-size-step',
        regenerateDailyContent: '/regenerate-daily-content',
        recommendedResources: '/recommended-resources',
        event:'/event',
        post:'/post', 
        comment:'/comment',
        provider:'/provider',
        providerSearch:'/provider-search',
        quickQuestion:'/generate-user-quick-questions',
        providerCategories:'/provider-categories',
        userSubscription: '/user-subscription',
        regenerateRoadMap: '/regenerate',
        appSettings: '/app-settings',
        helpRequest: '/help-request',
        usageStatus: '/usage-status',
        paywallDismiss: '/paywall-dismiss',
        sponsorship: '/sponsorship',
        homework: '/homework',
        homeworkComplete: '/homework/:id/complete',
    },
    admin: {
        publicResource: '/public-resource',
        user: '/user',
        knowledge: '/knowledge',
        chatPrompt: '/chat-prompt',
        provider:'/provider',
        providerCategories: '/provider-categories',
        analytics: '/analytics',
        appSettings: '/app-settings',
        aiStatus: '/ai-status',
        systemStatus: '/system-status',
        systemLogs: '/system-logs',
        roadmapMilestone: '/roadmap-milestone',
        roadmapSequence: '/roadmap-sequence',
        organization: '/organization',
    },
    provider: {
        me: '/me',
        member: '/member',
        license: '/license',
        licenseInvite: '/license/invite',
        family: '/family',
        homework: '/homework',
        note: '/note',
        analytics: '/analytics',
        roadmapReviews: '/roadmap-reviews',
    },
    public: {
    },
    auth: {
        register: '/register',
        login: '/login',
        logout: '/logout',
        whoami: '/whoami',
        refresh: '/refresh',
        forgotPassword: '/request-token',
        resetPassword: '/reset-password',
        resetTokenStatus: '/reset-token-status',
        verifyOtp: '/verify-otp',
        // Provider-staff auth (StaffUser collection, kind:'staff' tokens).
        providerLogin: '/provider/login',
        providerForgotPassword: '/provider/request-token',
        providerResetPassword: '/provider/reset-password',
    },

    stripe:{
        createCheckoutSession:'/create-checkout-session',
        createSubscriptionPortalSession:'/create-subscription-portal',
        subscription:'/subscription',
        webhook:'/webhook'
    }
}

/*
    !! DO NOT EDIT !!

    ENDPOINTS is identical to above, but is a separate copy so as to not be changed by the following process
        its used only on the backend in the request handlers

    ROUTES is for the frontend, the router prefixes are joined to the final endpoints
        so { router: { name: '/endpoint' }} becomes { router: { name: 'router/endpoint' }}
*/

export const ENDPOINTS = JSON.parse(JSON.stringify(endpoints)) as typeof endpoints

for (const [router, routes] of Object.entries(endpoints)) {
    for (const [name, endpoint] of Object.entries(routes)) {
        //@ts-ignore - router is definitely a key of endpoints
        endpoints[router][name] = `${router}${endpoint}`
    }
}

const ROUTES = Object.assign({}, endpoints) as typeof endpoints
export default ROUTES

